import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8dec3c0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "homepageContainer"
};
const _hoisted_3 = {
  class: "overview-title"
};
const _hoisted_4 = {
  class: "controlLine"
};
const _hoisted_5 = {
  class: "connected-platforms-label"
};
const _hoisted_6 = {
  class: "filters-block"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "connected-platforms-sorting-btn-separator"
}, null, -1));
const _hoisted_8 = {
  class: "create-platform-block"
};
const _hoisted_9 = {
  class: "create-platform-block__label"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_12 = {
  class: "tableContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_icon = _resolveComponent("w-icon");
  const _component_w_standard_button = _resolveComponent("w-standard-button");
  const _component_MainTitle = _resolveComponent("MainTitle");
  const _component_Banner = _resolveComponent("Banner");
  const _component_TotalSummaries = _resolveComponent("TotalSummaries");
  const _component_w_search_bar = _resolveComponent("w-search-bar");
  const _component_sort_dropdown = _resolveComponent("sort-dropdown");
  const _component_CardInteractive = _resolveComponent("CardInteractive");
  const _component_GridItem = _resolveComponent("GridItem");
  const _component_PlatformPreview = _resolveComponent("PlatformPreview");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  const _component_GridLayout = _resolveComponent("GridLayout");
  const _component_PlatformsTable = _resolveComponent("PlatformsTable");
  const _component_CenterTop = _resolveComponent("CenterTop");
  const _component_add_platform = _resolveComponent("add-platform");
  const _component_create_platform = _resolveComponent("create-platform");
  const _component_i18n_t = _resolveComponent("i18n-t");
  const _component_standard_notification_dialog = _resolveComponent("standard-notification-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CenterTop, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MainTitle, null, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('platforms_management.title')), 1)]),
      default: _withCtx(() => [_createVNode(_component_w_standard_button, {
        class: "connect-platform-btn",
        type: "primary",
        minWidth: "223px",
        disabled: !_ctx.isPlatformConnect,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.toggleConnectPlatformDialog = true)
      }, {
        default: _withCtx(() => [_createVNode(_component_w_icon, {
          icon: "link-variant"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('platforms_management.connect_platform_btn')), 1)]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }), !!_ctx.errorMsg ? (_openBlock(), _createBlock(_component_Banner, {
      key: 0,
      type: "error"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.errorMsg), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('platforms_management.overview.title')), 1), _createVNode(_component_TotalSummaries)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('platforms_management.connected_platforms_section.title')), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_w_search_bar, {
      placeholder: _ctx.$t('platforms_management.connected_platforms_section.search_platform_placeholder'),
      width: "254px",
      onOnInputUpdate: _ctx.onSearchInputUpdate
    }, null, 8, ["placeholder", "onOnInputUpdate"]), _createVNode(_component_sort_dropdown, {
      placement: "bottom-end",
      onOnItemSelected: _ctx.onSortChanges
    }, null, 8, ["onOnItemSelected"]), _hoisted_7, _createVNode(_component_w_icon, {
      icon: _ctx.isHomepageSimpleview ? 'view-list-outline' : 'view-module-outline',
      size: "22px",
      class: "connected-platforms-view-mode-toggle",
      onClick: _ctx.toggleSimpleView
    }, null, 8, ["icon", "onClick"])])]), _ctx.isHomepageSimpleview ? (_openBlock(), _createBlock(_component_GridLayout, {
      key: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_GridItem, {
        class: "grid-item"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(`${!_ctx.isPlatformCreator ? 'platform-creation-link--disabled' : ''}`),
          onClick: _cache[1] || (_cache[1] = $event => _ctx.togglePlatformCreationDialog = true)
        }, [_createVNode(_component_CardInteractive, {
          class: "create-platform-card"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_w_icon, {
            icon: "plus",
            size: "48px",
            class: "create-platform-block__icon"
          }), _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('platforms_management.connected_platforms_section.platform_creation_btn')), 1)])]),
          _: 1
        })], 2)]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platforms, platform => {
        return _openBlock(), _createBlock(_component_GridItem, {
          class: "grid-item",
          key: platform.platformID
        }, {
          default: _withCtx(() => [_createVNode(_component_PlatformPreview, {
            platform: platform,
            loading: _ctx.pfLoading[platform.platformID] !== false,
            errorMsg: _ctx.pfErrorMsg[platform.platformID]
          }, null, 8, ["platform", "loading", "errorMsg"])]),
          _: 2
        }, 1024);
      }), 128)), _createVNode(_component_infinite_loading, {
        onInfinite: _ctx.debounceInfinite,
        identifier: _ctx.infiniteLoaderID
      }, {
        "no-more": _withCtx(() => [_hoisted_10]),
        "no-results": _withCtx(() => [_hoisted_11]),
        _: 1
      }, 8, ["onInfinite", "identifier"])]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [!_ctx.isHomepageSimpleview ? (_openBlock(), _createBlock(_component_PlatformsTable, {
      key: 0
    })) : _createCommentVNode("", true)])])]),
    _: 1
  }), _createVNode(_component_add_platform, {
    "toggle-connect-platform-dialog": _ctx.toggleConnectPlatformDialog,
    onDialogClose: _cache[2] || (_cache[2] = $event => _ctx.toggleConnectPlatformDialog = false)
  }, null, 8, ["toggle-connect-platform-dialog"]), _createVNode(_component_create_platform, {
    "toggle-platform-creation-dialog": _ctx.togglePlatformCreationDialog,
    onDialogClose: _cache[3] || (_cache[3] = $event => _ctx.togglePlatformCreationDialog = false)
  }, null, 8, ["toggle-platform-creation-dialog"]), _ctx.shouldSuggestPlatformConnection() ? (_openBlock(), _createBlock(_component_standard_notification_dialog, {
    key: 0,
    title: _ctx.$t('home.initialization_dialog.title'),
    "toggle-dialog": _ctx.togglePlatformConnectionSuggestDialog
  }, {
    footer: _withCtx(() => [_createVNode(_component_w_standard_button, {
      type: "primary",
      "min-width": "199px",
      onClick: _ctx.onUserAcceptToConnectPlatform
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.initialization_dialog.confirm_btn').toString()), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_i18n_t, {
      scope: "global",
      keypath: "home.initialization_dialog.message.value",
      tag: "div"
    }, {
      first_step: _withCtx(() => [_createElementVNode("b", null, _toDisplayString(_ctx.$t('home.initialization_dialog.message.first_step')) + ": ", 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["title", "toggle-dialog"])) : _createCommentVNode("", true)]);
}